'use client';

import useBreakpoint from '@/hooks/useBreakpoint';
import { Produto } from '@/types/produto';
import { CSSProperties } from 'react';
import ListagemProdutosHomeMobile from './Designs/Mobile';
import ListagemProdutosHomeDesktop from './Designs/Desktop';

export type ListagemProdutosHomeProps = {
  $produtos: Array<Produto> | null;
  $loading: boolean;
  style?: CSSProperties;
  $funcaoAdicional?: () => void;
};

export default function ListagemProdutosHome(props: ListagemProdutosHomeProps) {
  const { breakpoint } = useBreakpoint();

  return breakpoint === 'mobile' ? (
    <ListagemProdutosHomeMobile {...props} />
  ) : (
    <ListagemProdutosHomeDesktop {...props} />
  );
}
